import React, { useEffect, useState, useMemo } from "react";
import useLocalSearch from "../../hooks/useLocalSearch";
import "./SingleIndex.css";
import { useAuth } from "../../context/AuthNewContext";
import { useSelectedStock } from "../../context/FavStockContext";
import { useIndexSnapshot } from "../../context/IndexContext";
import { TOOLTIPS } from "../../helper/tooltilData";
import { MdDelete } from "react-icons/md";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import MarketOverview from "../MarketOverview/MarketOverview";
import StockHelper from "../StockHelper/StockHelper";
const SingleIndex = () => {
  const {
    addSelectedStock,
    removeSelectedStock,

    selectedIndex,
    getSelectedStock,
    clearSelectedIndex,
  } = useSelectedStock();

  const {
    indexDetail,
    indexDetailLoading,
    indexDetailError,
    getIndexSnapshot,
    resetIndexSnapshot,
  } = useIndexSnapshot();
  const [selectedIndexName, setSelectedIndexName] = useState("");
  const [securityId, setSecurityId] = useState("");

  const { user } = useAuth();
  const userID = user?.userID;
  const {
    query: localSearch,
    setQuery: setLocalSearch,
    indexResults: localIndexResults,
    loading: localSearchLoading,
    clearResults: clearLocalResults,
  } = useLocalSearch();

  useEffect(() => {
    if (!userID) return;

    getSelectedStock(userID, "INDEX");
  }, [userID]);

  const handleAdd = async ({ displayName, securityId }) => {
    try {
      if (!userID || !displayName || !securityId) return;

      const formattedIndexName = displayName.trim().toUpperCase();

      setSelectedIndexName(formattedIndexName);
      setSecurityId(securityId);

      setLocalSearch("");
      clearLocalResults();
      toast.success(`${formattedIndexName} added successfully.`);

      await addSelectedStock({
        userID,
        symbol: formattedIndexName,
        securityId,
        type: "INDEX",
      });

      await getIndexSnapshot(formattedIndexName);

      await getSelectedStock(userID, "INDEX");
    } catch (err) {
      console.error("Add index failed:", err);
    }
  };
  const handleRemove = async () => {
    try {
      if (!userID || !finalIndexName) return;

      await removeSelectedStock({
        userID,
        symbol: finalIndexName,
        type: "INDEX",
      });

      clearSelectedIndex();
      resetIndexSnapshot();

      setSelectedIndexName("");
      setSecurityId("");
      setLocalSearch("");
      clearLocalResults();
      toast.success(`${finalIndexName} removed successfully.`);
    } catch (err) {
      console.error("Remove index failed:", err);
    }
  };

  const dbIndexName = selectedIndex?.[0]?.symbol;
  const dbSecurityId = selectedIndex?.[0]?.securityId;

  const finalIndexName = selectedIndexName || dbIndexName;
  const finalSecurityId = securityId || dbSecurityId;

  const hasSelectedIndex = !!finalIndexName;
  const navigate = useParams();
  useEffect(() => {
    if (!finalIndexName) return;

    getIndexSnapshot(finalIndexName);
  }, [finalIndexName]);

  //supoorted Indices
  const supportedIndices = [
    {
      displayName: "NIFTY 50",
      securityId: "13",
    },
    {
      displayName: "NIFTY BANK",
      securityId: "25",
    },
    {
      displayName: "NIFTY IT",
      securityId: "29",
    },
    {
      displayName: "NIFTY MIDCAP 100",
      securityId: "37",
    },
    {
      displayName: "NIFTY MIDCAP 50",
      securityId: "20",
    },
    {
      displayName: "NIFTY NEXT 50",
      securityId: "38",
    },
  ];

  console.log("indexDetail", indexDetail);

  return (
    <>
      {!hasSelectedIndex && (
        <div>
          {/* Future Scope */}
          {/* <div
            className="search-option-input"
            style={{
              borderRadius: "12px",
              width: "50%",
              display: "flex",
              alignItems: "center",
              padding: "0px 10px",
              background: "white",
              margin: "10px auto",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.4)",
              position: "relative",
            }}
          >
            <input
              type="text"
              placeholder="Search Stock"
              value={localSearch}
              onChange={(e) => setLocalSearch(e.target.value)}
              className="search-option-chain"
              style={{
                width: "100%",
                padding: "10px",
                outline: "none",
                border: "none",
              }}
            />

            {localIndexResults.length > 0 && (
              <div className="search-optionpage-dropdown index-dropdown">
                {localIndexResults.length > 0 && (
                  <>
                    <div className="search-section-title">Indices</div>

                    {localIndexResults.map((item, index) => (
                      <div
                        key={`index-${index}`}
                        className="search-option-dropdown-item "
                        onClick={async () => {
                          await handleAdd({
                            displayName: item?.displayName,
                            securityId: item?.securityId,
                          });
                        }}
                        
                      >
                        <div className="dropdown-symbol">
                          {item?.underlyingSymbol}
                        </div>
                        <div className="dropdown-company">
                          {item?.displayName}
                        </div>
                      </div>
                    ))}
                  </>
                )}
              </div>
            )}

            {localSearchLoading && <p>Searching...</p>}
          </div> */}
          <div className="one-index-note">
            <h3>What is One Index?</h3>

            <p>
              One Index allows you to analyze a single NSE index with live
              price, technical indicators, momentum insights, support/resistance
              levels, return performance, charts and option analytics.
            </p>

            <p>Currently supported indices:</p>

            {/* <div className="one-index-tags">
              <span>NIFTY 50</span>
              <span>NIFTY NEXT 50</span>
              <span>NIFTY IT</span>
              <span>NIFTY BANK</span>
              <span>NIFTY MIDCAP 50</span>
              <span>NIFTY MIDCAP 100</span>
            </div> */}
            <div className="supported-index-section">
              <h3>Click on anyone Index to add</h3>

              <div className="supported-index-grid">
                {supportedIndices.map((item) => (
                  <button
                    key={item.displayName}
                    className="supported-index-card"
                    onClick={() => handleAdd(item)}
                  >
                    <div className="supported-index-name">
                      {item.displayName}
                    </div>
                  </button>
                ))}
              </div>
            </div>

            <small>More indices will be added in upcoming releases.</small>
          </div>
        </div>
      )}

      {hasSelectedIndex && (
        <StockHelper
          symbol={finalIndexName}
          securityId={finalSecurityId}
          type="INDEX"
          onDelete={handleRemove}
        />
      )}
    </>
  );
};

export default SingleIndex;
